import { useEffect, useState } from "react";
import { IStatusPanelParams } from 'ag-grid-community';
import { Box, FormControl, IconButton, InputLabel, Select, SelectChangeEvent, Tooltip } from "@mui/material";
import { ChevronLeftRounded, ChevronRightRounded, FirstPageRounded, LastPageRounded } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import { useAgGridLocale } from "../../../config/globalConfig";

const GridStatusComponent = (props: IStatusPanelParams) => {

    const locale = useAgGridLocale();

    const [currentPage, setCurrentPage] = useState(0);
    const [maximumPage, setMaximumPage] = useState(0);

    const [firstRow, setFirstRow] = useState(0);
    const [lastRow, setLastRow] = useState(0);
    const [rows, setRows] = useState(0);

    const updateValues = () => {
        setCurrentPage(props.api.paginationGetTotalPages() === 0 ? 0 : props.api.paginationGetCurrentPage() + 1);
        setMaximumPage(props.api.paginationGetTotalPages());

        setFirstRow(props.api.getLastDisplayedRow() === -1 ? 0 : props.api.getFirstDisplayedRow() + 1);
        setLastRow(props.api.getLastDisplayedRow() + 1);
        setRows(props.api.getModel().getRowCount());
    }

    useEffect(() => {
        props.api.addEventListener('firstDataRendered', (params: any) => {
            updateValues();
        });
        props.api.addEventListener('paginationChanged', (params: any) => {
            updateValues();
        });
    }, []);


    return (
        <div className="ag-status-name-value" style={{ display: 'flex', alignItems: 'center', gap: '3ch', height: '100%' }}>
            <Box>
                <FormControl size="small">
                    <InputLabel>Rows</InputLabel>
                    <Select
                        disabled={rows <= props.api.paginationGetPageSize()}
                        value={props.api.paginationGetPageSize().toString()}
                        label="Rows"
                        onChange={(event: SelectChangeEvent) => props.api.paginationSetPageSize(Number.parseInt(event.target.value))}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={75}>75</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', gap: '1ch' }}>
                <span className="ag-status-name-value-value">{firstRow}</span>
                <span className="component" style={{ color: 'black' }}>{locale.to}</span>
                <span className="ag-status-name-value-value">{lastRow}</span>
                <span className="component" style={{ color: 'black' }}>{locale.of}</span>
                <span className="ag-status-name-value-value">{rows}</span>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', gap: '1ch' }}>
                <Tooltip arrow title={locale.firstPage}>
                    <span><IconButton onClick={() => props.api.paginationGoToFirstPage()}><FirstPageRounded sx={{ fontSize: 'inherit' }}/></IconButton></span>
                </Tooltip>
                <Tooltip arrow title={locale.previousPage}>
                    <span><IconButton onClick={() => props.api.paginationGoToPreviousPage()}><ChevronLeftRounded sx={{ fontSize: 'inherit' }}/></IconButton></span>
                </Tooltip>
                <span className="component" style={{ color: 'black' }}>{locale.page}</span>
                <span className="ag-status-name-value-value">{currentPage}</span>
                <span className="component" style={{ color: 'black' }}>{locale.to}</span>
                <span className="ag-status-name-value-value">{maximumPage}</span>
                <Tooltip arrow title={locale.nextPage}>
                    <span><IconButton onClick={() => props.api.paginationGoToNextPage()}><ChevronRightRounded sx={{ fontSize: 'inherit' }}/></IconButton></span>
                </Tooltip>
                <Tooltip arrow title={locale.lastPage}>
                    <span><IconButton onClick={() => props.api.paginationGoToLastPage()}><LastPageRounded sx={{ fontSize: 'inherit' }}/></IconButton></span>
                </Tooltip>
            </Box>
        </div>
    );
};

export default GridStatusComponent;